module.exports = __webpack_public_path__ + "assets/webgl/Frame_Painting_materialParams.1001.jpg.f3a26973.webp";